import axios from 'axios';
import { proxy } from '../../../package.json';

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : proxy;
axios.defaults.headers.post['Content-Type'] = 'application/json';

export default axios;
